import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "localization-page" }
const _hoisted_2 = { class: "header" }

import { ref, onMounted } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import {
  getLocalizationFiles,
  uploadLocalizationFile,
  activateLocalizationFile,
  deleteLocalizationFile,
  LocalizationFile,
} from '@/api/localization'


export default /*@__PURE__*/_defineComponent({
  __name: 'LocalizationList',
  setup(__props) {

const files = ref<LocalizationFile[]>([])
const loading = ref(false)

const fetchFiles = async () => {
  loading.value = true
  try {
    const response = await getLocalizationFiles()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    files.value = (response as any).data
  } catch (error) {
    console.error(error)
    ElMessage.error('Failed to fetch localization files')
  } finally {
    loading.value = false
  }
}

const handleUpload = async (options: any) => {
  try {
    await uploadLocalizationFile(options.file)
    ElMessage.success('File uploaded successfully')
    fetchFiles()
  } catch (error) {
    console.error(error)
    ElMessage.error('Failed to upload file')
  }
}

const handleActivate = async (file: LocalizationFile) => {
  try {
    await activateLocalizationFile(file.id)
    ElMessage.success('File activated successfully')
    fetchFiles()
  } catch (error) {
    console.error(error)
    ElMessage.error('Failed to activate file')
  }
}

const handleDelete = async (file: LocalizationFile) => {
  try {
    await deleteLocalizationFile(file.id)
    ElMessage.success('File deleted successfully')
    fetchFiles()
  } catch (error) {
    console.error(error)
    ElMessage.error('Failed to delete file')
  }
}

const formatDate = (date: string) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm')
}

onMounted(() => {
  fetchFiles()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Localization Files", -1)),
      _createVNode(_component_el_upload, {
        class: "upload-demo",
        action: "#",
        "http-request": handleUpload,
        "show-file-list": false,
        accept: ".csv"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Upload CSV")
            ])),
            _: 1,
            __: [0]
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_card, { class: "tutorial-card" }, {
      header: _withCtx(() => _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("span", null, "How to update localization")
        ], -1)
      ])),
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tutorial-content" }, [
          _createElementVNode("p", null, "1. Open the Google Sheet with translations."),
          _createElementVNode("p", null, [
            _createTextVNode(" 2. Go to "),
            _createElementVNode("strong", null, "File"),
            _createTextVNode(" > "),
            _createElementVNode("strong", null, "Download"),
            _createTextVNode(" > "),
            _createElementVNode("strong", null, "Comma Separated Values (.csv)"),
            _createTextVNode(". ")
          ]),
          _createElementVNode("p", null, [
            _createTextVNode(" 3. Upload the downloaded file using the "),
            _createElementVNode("strong", null, "Upload CSV"),
            _createTextVNode(" button. ")
          ])
        ], -1))
      ]),
      _: 1,
      __: [3]
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: files.value,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          width: "300"
        }),
        _createVNode(_component_el_table_column, {
          prop: "original_name",
          label: "Filename"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "Created At"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(formatDate(scope.row.created_at)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Status",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.is_active ? 'success' : 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.is_active ? 'Active' : 'Inactive'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Actions",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            (!scope.row.is_active)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "success",
                  onClick: ($event: any) => (handleActivate(scope.row))
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Activate ")
                  ])),
                  _: 2,
                  __: [4]
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (files.value.length > 1)
              ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 1,
                  title: "Are you sure to delete this file?",
                  onConfirm: ($event: any) => (handleDelete(scope.row))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("Delete")
                      ])),
                      _: 1,
                      __: [5]
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ])
  ]))
}
}

})